import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@applyonline/shared';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PHONE_NUMBER_IFINANCE, PHONE_NUMBER_LINK_IFINANCE } from '../../types';
const ProblemOccuredAlert = ({ showAlert }) => {
    const alertRef = useRef(null);
    const { t } = useTranslation();
    useEffect(() => {
        if (showAlert && alertRef.current) {
            alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [showAlert]);
    return showAlert ? (_jsx("div", { ref: alertRef, children: _jsx(Alert, { type: "warn", message: t('common.errors.problemOccuredContactUs', { ns: 'shared' }), linkText: PHONE_NUMBER_IFINANCE, linkType: "tel", link: PHONE_NUMBER_LINK_IFINANCE.replace('tel:', '') }) })) : null;
};
export default ProblemOccuredAlert;
